fragment CommentFragment on Comment {
  id
  createdAtNonLocalized
  ancestors {
    id
    __typename
  }
  author {
    type
    displayName
    profilePicture {
      path
      __typename
    }
    ... on KnownUser {
      accountId
      permissionType
      __typename
    }
    __typename
  }
  body(representation: ATLAS_DOC_FORMAT) {
    value
    __typename
  }
  contentStatus
  links {
    webui
    __typename
  }
  parentId
  permissions {
    isEditable
    isRemovable
    __typename
  }
  version {
    friendlyWhen
    number
    when
    by {
      type
      displayName
      ... on KnownUser {
        accountId
        __typename
      }
      __typename
    }
    __typename
  }
  location {
    type
    ... on InlineComment {
      inlineResolveProperties {
        resolved
        __typename
      }
      inlineMarkerRef
      __typename
    }
    __typename
  }
  __typename
}
